import React, { useState, useEffect } from "react";
import {
  MDBRow,
  MDBCol,
  MDBInput,
  MDBBtn,
  MDBModal,
  MDBModalBody,
  MDBModalHeader,
  MDBIcon,
  MDBCardHeader,
  MDBCard,
  MDBCardBody,
} from "mdbreact";
/* import { MDBContainer, MDBRow, MDBCol, MDBInput, MDBBtn, MDBIcon
  ,MDBModal,MDBModalBody , MDBModalHeader, MDBModalFooter } from 'mdbreact'; */

import Axios from "axios";

import DatePicker from "react-datepicker";

import "react-datepicker/dist/react-datepicker.css";

import WarningBox from "../components/WarningBox";
import InfoBox from "../components/InfoBox";
import Select from "react-select";
import CreatableSelect from "react-select/creatable";
import { set } from "date-fns";
import Vehicle from "../Vehicle/Vehicle";
import Customer from "../Customer/Customer";
import AddEditVehicle from "../Vehicle/AddEditVehicle";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faGear,
  faScrewdriverWrench,
  faUser,
} from "@fortawesome/free-solid-svg-icons";
import AddEditCustomer from "../Customer/AddEditCustomer";
import { Bounce, ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Save } from "@material-ui/icons";
import { useDispatch } from "react-redux";
import {
  setCustomerTicket,
  setDiscountCode,
  setDiscountRate,
  setDiscountType,
  setStatus,
  setTransactionDate,
} from "../features/sales/salesSlice";
const AddEditSalesMain = (props) => {
  const useMountEffect = (functionName) => useEffect(functionName, []);
  const serverURL = props.apiServer;
  const bearer = {
    headers: {
      Authorization: "Bearer " + sessionStorage.getItem("hash"),
    },
  };
  const dispatch = useDispatch();
  const [frm, setValues] = useState({
    // code:"new"
    code: props.code,
    transactiondatetime: new Date(),
    clienttime: new Date().toTimeString(),
    deleted: false,
    paid: true,
    datepaid: new Date(),
    discountcode: { value: "0", label: "[NO DISCOUNT]" },
    referenceno: "",
    paymentmode: { value: "1", label: "Cash" },
    usercode: sessionStorage.getItem("msal.uc"),
    scpwdnumber: "",
    vehiclecode: { value: "0", label: "No Selection" },
    mileage: 0,
    nextpms: { value: "1", label: "6000" },
    notes: "***NOTE: DUE FOR CHANGE OIL ",
    customercode: { value: "0", label: "[CLIENT]" },
    ornumber: "",
    showornumber: false,
    shownotes: false,
    mechanicincharge: "N/A",
    sinumber: "",
    notes2: "***NOTE: ",
    shownotes2: false,
    printed: false,
  });

  const notify = (message) => {
    toast(() => message, {
      position: "top-right",
      autoClose: 2000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "dark",
      transition: Bounce,
      className: "font-weight-bold blue-text",
    });
  };

  const [modalVehicleQuickAddOption, showVehicleQuickAddOption] =
    useState(false);
  const toggleVehicleQuickAddOption = () => {
    loadVehicleoption();
    showVehicleQuickAddOption(!modalVehicleQuickAddOption);
  };
  const [modalVehicleOption, showVehicleOption] = useState(false);
  const toggleVehicleOption = () => {
    loadVehicleoption();
    showVehicleOption(!modalVehicleOption);
  };
  const [vehicleoptions, setvehicleoptions] = useState([]);
  const loadVehicleoption = () => {
    Axios.get(serverURL + "/getvehicleoptions", bearer)
      .then((res) => {
        setvehicleoptions(res.data);
      })

      .catch((error) => {
        setErrorMessage(error);
        toggleWarningBox();
      });
  };

  const [modalCustomerQuickAddOption, showCustomerQuickAddOption] =
    useState(false);
  const toggleCustomerQuickAddOption = () => {
    loadcustomeroption();
    showCustomerQuickAddOption(!modalCustomerQuickAddOption);
  };
  const [modalCustomerOption, showCustomerOption] = useState(false);
  const toggleCustomerOption = () => {
    loadcustomeroption();
    showCustomerOption(!modalCustomerOption);
  };
  const [customeroptions, setcustomeroptions] = useState([]);
  const loadcustomeroption = () => {
    Axios.get(serverURL + "/getcustomeroptions", bearer)
      .then((res) => {
        setcustomeroptions(res.data);
      })

      .catch((error) => {
        setErrorMessage(error);
        toggleWarningBox();
      });
  };
  const [sDate, setDate] = useState(new Date());
  const [isUpdated, setUpdated] = useState(false);
  const [unitofmeasure, setUnitOfMeasure] = useState("");
  const [disabled, setDisabled] = useState("");
  const [hidden, setHidden] = useState(false);
  const updateField = (e) => {
    const target = e.target;

    let value = target.value;
    let name = target.id;

    if (target.type === "checkbox") {
      value = target.checked;
      setValues({ ...frm, [name]: value });
    } else {
      setValues({ ...frm, [name]: value });
    }
  };

  const handleChange = (objName) => (selOption) => {
    setValues({ ...frm, [objName]: selOption });
  };

  const getDateValue = (dtPickerName) => (actualValue) => {
    setValues({ ...frm, [dtPickerName]: actualValue });
  };

  function submitHandler(event) {
    event.preventDefault();
    event.target.className += " was-validated";

    savesalesmain();
  }

  const [errorMessage, setErrorMessage] = useState("");

  const [modalWarning, showWarningBox] = useState(false);

  const toggleWarningBox = () => {
    showWarningBox(!modalWarning);
  };

  const [modalInfo, showInfoBox] = useState(false);

  const toggleInfoBox = () => {
    showInfoBox(!modalInfo);
  };

  const [discountoptions, setdiscountoptions] = useState([]);
  const loaddealer = () => {
    Axios.get(serverURL + "/getdiscountoptions", bearer)
      .then((res) => {
        setdiscountoptions(res.data);
      })

      .catch((error) => {
        setErrorMessage(error);
        toggleWarningBox();
      });
  };

  const [paymentmodeoptions, setpaymentmodeoptions] = useState([]);
  const loaddpaymentmode = () => {
    Axios.get(serverURL + "/getpaymentmode", bearer)
      .then((res) => {
        setpaymentmodeoptions(res.data);
      })

      .catch((error) => {
        setErrorMessage(error);
        toggleWarningBox();
      });
  };

  const [nextpmsoptions, setnextpmsoptions] = useState([]);
  const loadnextpmsoption = () => {
    Axios.get(serverURL + "/getnextpmsoptions", bearer)
      .then((res) => {
        setnextpmsoptions(res.data);
      })

      .catch((error) => {
        setErrorMessage(error);
        toggleWarningBox();
      });
  };
  const ClearFields = () => {
    setValues({
      ...frm,
      code: "new",
      transactiondatetime: new Date(),
      clienttime: new Date().toTimeString(),
      deleted: false,
      paid: true,
      datepaid: new Date(),
      discountcode: { value: "0", label: "[NO DISCOUNT]" },
      referenceno: "",
      paymentmode: { value: "1", label: "Cash" },
      usercode: sessionStorage.getItem("msal.uc"),
      scpwdnumber: "",
      vehiclecode: { value: "0", label: "No Selection" },
      mileage: 0,
      nextpms: { value: "1", label: "6000" },
      notes: "***NOTE: DUE FOR CHANGE OIL ",
      customercode: { value: "0", label: "CLIENT" },
      ornumber: "",
      showornumber: false,
      shownotes: false,
      mechanicincharge: "N/A",

      sinumber: "",
      notes2: "***NOTE: ",
      shownotes2: false,
      printed: false,
    });
  };

  const loadtransactionsalesmain = () => {
    if (props.code === "new") {
      setDisabled("");
      ClearFields();
      return;
    }
    setDisabled("disabled");
    Axios.get(
      serverURL + "/loadtransactionsalesmain/?code=" + props.code,
      bearer
    )
      .then((res) => {
        if (res.data !== "empty") {
          setDisabled("disabled");
          setValues({
            ...frm,

            code: props.code,
            transactiondatetime: new Date(res.data.transactiondatetime),

            deleted: res.data.deleted,
            paid: res.data.paid,
            datepaid: new Date(res.data.datepaid),
            discountcode: {
              value: res.data.discountcode,
              label: res.data.discount,
            },
            referenceno: res.data.referenceno,
            paymentmode: {
              value: res.data.paymentmodecode,
              label: res.data.paymentmode,
            },

            scpwdnumber: res.data.scpwdnumber,
            vehiclecode: {
              value: res.data.vehiclecode,
              label: res.data.vehicle,
            },
            mileage: res.data.mileage,
            nextpms: { value: res.data.nextpmscode, label: res.data.nextpms },
            notes: res.data.notes,
            customercode: {
              value: res.data.customercode,
              label: res.data.customer,
            },
            ornumber: res.data.ornumber,
            showornumber: res.data.showornumber,
            shownotes: res.data.shownotes,
            mechanicincharge: res.data.mechanicincharge,
            mechanicincharge: "N/A",
            sinumber: res.data.sinumber,
            notes2: res.data.notes2,
            shownotes2: res.data.shownotes2,
            printed: res.data.printed,
          });

          //update state
          dispatch(setDiscountType(res.data.discount));
          dispatch(setDiscountCode(res.data.discountcode));
          dispatch(setDiscountRate(res.data.discountrate));
          dispatch(setStatus(res.data.printed));
        } else {
          ClearFields();
        }
      })

      .catch((error) => {
        setErrorMessage(error);
        toggleWarningBox();
      });
  };

  const [itemUpdated, setItemUpdated] = useState(false);
  const toggleUpdated = (x) => {
    setItemUpdated(x);
  };
  const savesalesmain = () => {
    if (frm.vehiclecode.value === "0") {
      setErrorMessage("Please select a vehicle!");
      toggleWarningBox();
      return;
    }
    const data = frm;
    setItemUpdated(false);

    Axios.post(props.apiServer + "/savesalesmain", data, bearer)
      .then((res) => {
        if (res.data.status === "1") {
          setValues({ ...frm, code: res.data.code });
          if (props.code === "new") {
            //update state
            dispatch(setCustomerTicket(res.data.code));
            dispatch(setTransactionDate(res.data.transactiondate));
            dispatch(setDiscountType(res.data.discount));
            dispatch(setDiscountCode(res.data.discountcode));
            dispatch(setDiscountRate(res.data.discountrate));
            dispatch(setStatus(res.data.printed));
            props.checkTotalSales();
            props.toggleModal();
          }
          notify(res.data.message);
          setItemUpdated(true);

          // props.refreshGrid(res.data.message);
        } else {
          toast.error(res.data.message, {
            closeButton: false,
          });

          setErrorMessage(res.data.message);
          toggleWarningBox();
        }
      })
      .catch((error) => {
        setErrorMessage(error);
        toggleWarningBox();
      });

    //  loadtransactionsalesmain();
  };

  const [isAdmin, checkAdmin] = useState(0);

  function checkAdminAccess() {
    Axios.get(
      props.apiServer +
        "/getadminaccess?username=" +
        sessionStorage.getItem("msal.uc"),
      bearer
    )
      .then((res) => {
        checkAdmin(0);
        checkAdmin(res.data[0].isadmin);
        setPreloader("none");
      })

      .catch((error) => {
        console.log(error);
      });
  }

  const [modalDelete, showDeleteBox] = useState(false);

  const deleteRecord = () => {
    if (props.code === "new") {
      setErrorMessage("Please select a record!");
      toggleWarningBox();

      return;
    }

    showDeleteBox(!modalDelete);
  };

  function confirmDelete() {
    removeSeedPlanting();

    showDeleteBox(!modalDelete);
  }

  const removeSeedPlanting = () => {
    const data = frm;

    Axios.post(props.apiServer + "/removeSeedPlanting", data, bearer)
      .then((res) => {
        if (res.data.status === "1") {
          // props.refreshGrid(res.data.message);
        } else {
          setErrorMessage(res.data.message);
          //  toggleWarningBox();
        }
      })
      .catch((error) => {
        setErrorMessage(error);
        //  toggleWarningBox();
      });

    //  props.refreshGrid(res.data.message);
  };

  const SaveButton = (props) => {
    return (
      <>
        {" "}
        {props.code === "new" ? (
          <>
            <MDBBtn
              className="blue lighten-1"
              onClick={() => props.savesalesmain()}
            >
              Save
            </MDBBtn>
            <MDBBtn
              className="cloudy-knoxville-gradient blue-text"
              onClick={props.toggleModal}
            >
              Close
            </MDBBtn>
          </>
        ) : (
          <>
            <MDBBtn
              className="blue lighten-1"
              onClick={() => props.savesalesmain()}
            >
              Save
            </MDBBtn>
          </>
        )}
      </>
    );
  };

  useEffect(() => {
    // console.log(frm.code);
    if (frm.code === "new") {
      setHidden(true);
    } else {
    }
  }, [frm]);
  useMountEffect(loaddealer);
  useMountEffect(loadVehicleoption);
  useMountEffect(loadcustomeroption);
  useMountEffect(loadnextpmsoption);
  useMountEffect(loaddpaymentmode);
  useMountEffect(checkAdminAccess);
  /* eslint-disable */
  // console.log(itemUpdated);
  useEffect(() => {
    loadtransactionsalesmain();
  }, [props.code, itemUpdated]);

  // useMountEffect(loadSeedPlanting);

  return (
    <React.Fragment>
      <MDBCardHeader>
        <MDBRow>
          <MDBCol MDBCol="10">
            {" "}
            <span
              className="h5-responsive blue-text"
              style={{
                fontFamily: "Montserrat",
                fontWeight: "400",
              }}
            >
              <span className="blue-text">
                <FontAwesomeIcon icon={faScrewdriverWrench} />
              </span>
              &nbsp;Ticket Details
            </span>
          </MDBCol>
          <MDBCol MDBCol="2" className="text-right">
            <SaveButton
              toggleModal={props.toggleModal}
              code={props.code}
              savesalesmain={savesalesmain}
            />
          </MDBCol>
        </MDBRow>
      </MDBCardHeader>

      <MDBCardBody>
        <MDBRow>
          <MDBCol md="12">
            <form
              className="needs-validation"
              onSubmit={submitHandler}
              noValidate
            >
              {props.code === "new" ? (
                <></>
              ) : (
                <>
                  <MDBRow>
                    <MDBCol md="12">
                      <MDBInput
                        value={frm.code}
                        id="code"
                        label="Customer Ticket"
                        disabled
                        className="font-weight-bold"
                      >
                        <div className="invalid-feedback">
                          This field is required!
                        </div>
                        <div className="valid-feedback"></div>
                      </MDBInput>
                    </MDBCol>
                  </MDBRow>
                  <MDBRow>
                    <MDBCol md="12">
                      <MDBInput
                        value={frm.transactiondatetime.toDateString()}
                        id="transactiondatetime"
                        label="Transaction Date/Time"
                        disabled
                        className="font-weight-bold black-text"
                      >
                        <div className="invalid-feedback">
                          This field is required!
                        </div>
                        <div className="valid-feedback"></div>
                      </MDBInput>
                    </MDBCol>
                  </MDBRow>
                </>
              )}

              {/* <MDBRow>
              <MDBCol md="10">
                <h3 className="h3-responsive font-weight-bold blue-text">
                  Transaction Date: &nbsp;
                  {sDate.toDateString()}{" "}
                </h3>
              </MDBCol>
            </MDBRow> */}

              {/* BirthDate */}
              <MDBRow hidden>
                <MDBCol md="10">
                  <DatePicker
                    placeholderText="mm/dd/yyyy"
                    selected={frm.transactiondatetime}
                    onChange={getDateValue("transactiondatetime")}
                    className={disabled}
                  />
                  <br />
                  <br />
                </MDBCol>
              </MDBRow>
              <MDBRow>
                <MDBCol md="12">
                  {" "}
                  <hr />
                  <h3 className="h5-responsive font-weight-bold brown-text">
                    VEHICLE DETAILS
                  </h3>
                </MDBCol>
              </MDBRow>

              <MDBRow>
                <MDBCol md="8" className="text-left">
                  <label className="grey-text">
                    <small>&nbsp;Vehicle</small>
                  </label>
                  <br />
                  <Select
                    placeholderText="Vehicle"
                    isSearchable
                    value={frm.vehiclecode}
                    onChange={handleChange("vehiclecode")}
                    options={vehicleoptions}
                    className={disabled}
                  />

                  <div className="invalid-feedback">
                    This field is required!
                  </div>
                  <div className="valid-feedback">Looks good!</div>

                  <br />
                </MDBCol>

                <MDBCol md="4" className="ml-0 pt-4 pr-0">
                  <MDBBtn
                    size="sm"
                    onClick={toggleVehicleQuickAddOption}
                    className="grey lighten-5 brown-text"
                  >
                    <MDBIcon icon="plus" />
                  </MDBBtn>
                  <MDBBtn
                    size="sm"
                    onClick={toggleVehicleOption}
                    className="grey lighten-5 brown-text"
                  >
                    <FontAwesomeIcon icon={faGear} />
                  </MDBBtn>
                </MDBCol>
              </MDBRow>

              <MDBRow hidden={hidden}>
                <MDBCol md="6">
                  <MDBInput
                    value={frm.mileage}
                    id="mileage"
                    label="Current Mileage (KM)"
                    onChange={updateField}
                    required
                    type="number"
                    className="black-text"
                  >
                    <div className="invalid-feedback">
                      This field is required!
                    </div>
                    <div className="valid-feedback"></div>
                  </MDBInput>
                </MDBCol>
                <MDBCol md="6">
                  <label className="grey-text">
                    <small>&nbsp;Next PMS</small>
                  </label>
                  <br />
                  <Select
                    placeholderText="Select Next PMS"
                    isSearchable
                    value={frm.nextpms}
                    onChange={handleChange("nextpms")}
                    options={nextpmsoptions}
                    // required
                  />

                  <div className="invalid-feedback ">
                    This field is required!
                  </div>
                  <div className="valid-feedback"></div>

                  <br />
                </MDBCol>
              </MDBRow>
              <MDBRow hidden={hidden}>
                <MDBCol md="10">
                  <MDBInput
                    value={frm.mechanicincharge}
                    id="mechanicincharge"
                    label="Mechanic-In-Charge"
                    onChange={updateField}
                    className="font-weight-bold black-text"
                  >
                    <div className="invalid-feedback">
                      This field is required!
                    </div>
                    <div className="valid-feedback"></div>
                  </MDBInput>
                </MDBCol>
              </MDBRow>
              <MDBRow hidden={hidden}>
                <MDBCol md="12">
                  <MDBInput
                    value={frm.notes}
                    id="notes"
                    label="Notes"
                    onChange={updateField}
                    className="black-text"
                  >
                    <div className="invalid-feedback">
                      This field is required!
                    </div>
                    <div className="valid-feedback"></div>
                  </MDBInput>
                </MDBCol>
              </MDBRow>
              <MDBRow hidden={hidden}>
                <MDBCol md="12">
                  <MDBInput
                    id="shownotes"
                    label="Show Notes when Printing"
                    type="checkbox"
                    checked={frm.shownotes}
                    onChange={updateField}
                    labelClass="blue-text font-weight-bold"
                    className="font-weight-bold"
                  >
                    <div className="invalid-feedback">
                      This field is required!
                    </div>
                    <div className="valid-feedback"></div>
                  </MDBInput>
                </MDBCol>
              </MDBRow>
              <MDBRow hidden={hidden}>
                <MDBCol md="12">
                  <MDBInput
                    value={frm.notes2}
                    id="notes2"
                    label="Additional Notes"
                    onChange={updateField}
                    className="black-text"
                  >
                    <div className="invalid-feedback">
                      This field is required!
                    </div>
                    <div className="valid-feedback"></div>
                  </MDBInput>
                </MDBCol>
              </MDBRow>
              <MDBRow hidden={hidden}>
                <MDBCol md="12">
                  <MDBInput
                    id="shownotes2"
                    label="Show Additional Notes when Printing"
                    type="checkbox"
                    checked={frm.shownotes2}
                    onChange={updateField}
                    labelClass="blue-text font-weight-bold"
                    className="font-weight-bold"
                  >
                    <div className="invalid-feedback">
                      This field is required!
                    </div>
                    <div className="valid-feedback"></div>
                  </MDBInput>
                </MDBCol>
              </MDBRow>
              <MDBRow>
                <MDBCol md="12">
                  {" "}
                  <hr />
                  <h3 className="h5-responsive font-weight-bold brown-text">
                    CUSTOMER DETAILS
                  </h3>
                </MDBCol>
              </MDBRow>
              <MDBRow>
                <MDBCol md="8" className="text-left">
                  <label className="grey-text">
                    <small>&nbsp;Customer</small>
                  </label>
                  <br />
                  <Select
                    placeholderText="Customer"
                    isSearchable
                    value={frm.customercode}
                    onChange={handleChange("customercode")}
                    options={customeroptions}
                    required
                  />

                  <div className="invalid-feedback">
                    This field is required!
                  </div>
                  <div className="valid-feedback">Looks good!</div>

                  <br />
                </MDBCol>

                <MDBCol md="4" className="ml-0 pt-4 pr-0">
                  <MDBBtn
                    size="sm"
                    onClick={toggleCustomerQuickAddOption}
                    className="grey lighten-5 brown-text"
                  >
                    <MDBIcon icon="plus" />
                  </MDBBtn>
                  <MDBBtn
                    size="sm"
                    onClick={toggleCustomerOption}
                    className="grey lighten-5 brown-text"
                  >
                    <FontAwesomeIcon icon={faGear} />
                  </MDBBtn>
                </MDBCol>
              </MDBRow>
              <MDBRow hidden={hidden}>
                <MDBCol md="10">
                  <label className="grey-text">
                    <small>&nbsp;Discount</small>
                  </label>
                  <br />
                  <Select
                    placeholderText="Select Discount"
                    isSearchable
                    value={frm.discountcode}
                    onChange={handleChange("discountcode")}
                    options={discountoptions}
                    // className={disabled}
                  />

                  <div className="invalid-feedback ">
                    This field is required!
                  </div>
                  <div className="valid-feedback"></div>

                  <br />
                </MDBCol>
              </MDBRow>
              <MDBRow hidden={hidden}>
                <MDBCol md="10">
                  <label className="grey-text">
                    <small>&nbsp;Mode of Payment</small>
                  </label>
                  <br />
                  <Select
                    placeholderText="Select Mode of Payment"
                    isSearchable
                    value={frm.paymentmode}
                    onChange={handleChange("paymentmode")}
                    options={paymentmodeoptions}
                    required
                    // className={disabled}
                  />
                  <br />
                </MDBCol>
              </MDBRow>
              <MDBRow hidden={hidden}>
                <MDBCol md="10">
                  <MDBInput
                    value={frm.referenceno}
                    id="referenceno"
                    label="Reference Number"
                    onChange={updateField}
                    className="font-weight-bold black-text"
                  >
                    <div className="invalid-feedback">
                      This field is required!
                    </div>
                    <div className="valid-feedback"></div>
                  </MDBInput>
                </MDBCol>
              </MDBRow>
              <MDBRow hidden={hidden}>
                <MDBCol md="6">
                  <MDBInput
                    value={frm.ornumber}
                    id="ornumber"
                    label="OR Number"
                    onChange={updateField}
                    className="font-weight-bold black-text"
                  >
                    <div className="invalid-feedback">
                      This field is required!
                    </div>
                    <div className="valid-feedback"></div>
                  </MDBInput>
                </MDBCol>
                <MDBCol md="6">
                  <MDBInput
                    value={frm.sinumber}
                    id="sinumber"
                    label="SI Number"
                    onChange={updateField}
                    className="font-weight-bold black-text"
                  >
                    <div className="invalid-feedback">
                      This field is required!
                    </div>
                    <div className="valid-feedback"></div>
                  </MDBInput>
                </MDBCol>
              </MDBRow>
              <MDBRow hidden={hidden}>
                <MDBCol md="12">
                  <MDBInput
                    id="showornumber"
                    label="Show OR Number and Sales Invoice"
                    type="checkbox"
                    checked={frm.showornumber}
                    onChange={updateField}
                  >
                    <div className="invalid-feedback">
                      This field is required!
                    </div>
                    <div className="valid-feedback"></div>
                  </MDBInput>
                </MDBCol>
              </MDBRow>

              {/* <MDBRow  >
                       <MDBCol md="12">
                       <MDBInput  
                      
                      
                      id="paid" 
                      label="Paid" 
                      type="checkbox"
                      checked={frm.paid}
                      onChange={updateField}
                      
                     >
                      
                          <div className="invalid-feedback">
                          This field is required!
                      </div>
                      <div className="valid-feedback"></div>

                  </MDBInput>
                      
                       </MDBCol>

                       
                      
                   </MDBRow> */}

              {/* <MDBRow>
                        <MDBCol md="4">
                        <label className="grey-text"><small>&nbsp;Date of Payment</small></label><br/>
                        <DatePicker
                        
                        placeholderText="mm/dd/yyyy"
                        selected={frm.datepaid}
                         onChange={getDateValue("datepaid")}  
                            
                        />
                        <br/><br/>
                        </MDBCol>
                    </MDBRow> */}

              {/* <MDBRow>
              <MDBCol md="8">
                <label className="grey-text">
                  <small>&nbsp;Mode of Payment</small>
                </label>
                <br />
                <Select
                  placeholderText="Select Mode of Payment"
                  isSearchable
                  value={frm.paymentmode}
                  onChange={handleChange("paymentmode")}
                  options={paymentmodeoptions}
                  required
                  className={disabled}
                />

                <div className="invalid-feedback ">This field is required!</div>
                <div className="valid-feedback"></div>

                <br />
              </MDBCol>
            </MDBRow> */}

              {/* <MDBRow>
              <MDBCol md="6">
                <MDBInput
                  value={frm.scpwdnumber}
                  id="scpwdnumber"
                  label="Senior Citizen / PWD ID Number"
                  onChange={updateField}
                  className="font-weight-bold black-text"
                >
                  <div className="invalid-feedback">
                    This field is required!
                  </div>
                  <div className="valid-feedback"></div>
                </MDBInput>
              </MDBCol>
              <MDBCol md="6">
                <MDBInput
                  value={frm.referenceno}
                  id="referenceno"
                  label="Reference Number"
                  onChange={updateField}
                  className="font-weight-bold black-text"
                >
                  <div className="invalid-feedback">
                    This field is required!
                  </div>
                  <div className="valid-feedback"></div>
                </MDBInput>
              </MDBCol>
            </MDBRow> */}

              {/* {props.code === "new" ? (
                <>
                  <MDBBtn className="blue lighten-1" type="submit">
                    Save
                  </MDBBtn>
                  <MDBBtn
                    className="cloudy-knoxville-gradient blue-text"
                    onClick={props.toggleModal}
                  >
                    Close
                  </MDBBtn>
                </>
              ) : (
                <>
                  <MDBBtn className="blue lighten-1" type="submit">
                    Save
                  </MDBBtn>
                </>
              )} */}
              <SaveButton
                toggleModal={props.toggleModal}
                code={props.code}
                savesalesmain={savesalesmain}
              />
            </form>
          </MDBCol>
        </MDBRow>
      </MDBCardBody>
      <MDBModal backdrop={false} isOpen={modalDelete} toggle={deleteRecord}>
        <MDBModalHeader
          className="text-left black-text cloudy-knoxville-gradient"
          titleClass="w-100"
          tag="h5"
        ></MDBModalHeader>
        <MDBModalBody className="text-center">
          <MDBRow>
            <MDBCol size="3" className="text-center">
              <MDBIcon icon="trash-alt" size="5x" className="red-text" />
            </MDBCol>
            <MDBCol size="9" className="black-text text-center">
              <p></p>
              <p>Do you really want to delete this record?</p>
              <p className="text-center">
                <MDBBtn color="danger" onClick={confirmDelete}>
                  Yes
                </MDBBtn>
                <MDBBtn
                  className="cloudy-knoxville-gradient blue-text"
                  onClick={deleteRecord}
                >
                  Cancel
                </MDBBtn>
              </p>
            </MDBCol>
          </MDBRow>
        </MDBModalBody>
      </MDBModal>
      <MDBModal
        backdrop={false}
        isOpen={modalVehicleOption}
        fullHeight
        position="right"
        size="lg"
      >
        <MDBModalHeader
          toggle={toggleVehicleOption}
          className="cloudy-knoxville-gradient"
        >
          <span className="h6-responsive brown-text font-weight-bold">
            Vehicle Dropdown Management
          </span>
        </MDBModalHeader>
        <MDBModalBody>
          <Vehicle
            deployURL={props.deployURL}
            apiServer={props.apiServer}
            apiServerHybrid={props.apiServerHybrid}
            quicktool={"yes"}
            toggleModal2={toggleVehicleOption}
          />
        </MDBModalBody>
      </MDBModal>
      <MDBModal
        backdrop={false}
        isOpen={modalVehicleQuickAddOption}
        fullHeight
        position="right"
        size="lg"
      >
        <MDBModalHeader
          toggle={toggleVehicleQuickAddOption}
          className="cloudy-knoxville-gradient"
        >
          <span className="h6-responsive brown-text font-weight-bold">
            Add Vehicle
          </span>
        </MDBModalHeader>
        <MDBModalBody>
          <AddEditVehicle
            deployURL={props.deployURL}
            apiServer={props.apiServer}
            apiServerHybrid={props.apiServerHybrid}
            quickadd={"yes"}
            toggleModal2={toggleVehicleQuickAddOption}
          />
        </MDBModalBody>
      </MDBModal>
      <MDBModal
        backdrop={false}
        isOpen={modalCustomerOption}
        fullHeight
        position="right"
        size="lg"
      >
        <MDBModalHeader
          toggle={toggleCustomerOption}
          className="cloudy-knoxville-gradient"
        >
          <span className="h6-responsive brown-text font-weight-bold">
            Customer Dropdown Management
          </span>
        </MDBModalHeader>
        <MDBModalBody>
          <Customer
            deployURL={props.deployURL}
            apiServer={props.apiServer}
            apiServerHybrid={props.apiServerHybrid}
            quicktool={"yes"}
            toggleModal2={toggleCustomerOption}
          />
        </MDBModalBody>
      </MDBModal>
      <MDBModal
        backdrop={false}
        isOpen={modalCustomerQuickAddOption}
        fullHeight
        position="right"
        size="lg"
      >
        <MDBModalHeader
          toggle={toggleCustomerQuickAddOption}
          className="cloudy-knoxville-gradient"
        >
          <span className="h6-responsive brown-text font-weight-bold">
            Add Customer
          </span>
        </MDBModalHeader>
        <MDBModalBody>
          <AddEditCustomer
            deployURL={props.deployURL}
            apiServer={props.apiServer}
            apiServerHybrid={props.apiServerHybrid}
            quickadd={"yes"}
            toggleModal2={toggleCustomerQuickAddOption}
          />
        </MDBModalBody>
      </MDBModal>
      {/* <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
        transition={Bounce}
      ></ToastContainer> */}

      <InfoBox
        errorMessage={errorMessage}
        isOpen={modalInfo}
        toggleModal={toggleInfoBox}
      />
      <WarningBox
        errorMessage={errorMessage}
        isOpen={modalWarning}
        toggleModal={toggleWarningBox}
      />
      {/* <MessagePersonalInfo /> */}
    </React.Fragment>
  );
};
export default AddEditSalesMain;
